import api from "@/lib/api";

// Per-user, per-language temporary workspace (unsaved draft) persisted in localStorage.
// One working project slot per language per user. Restores exact files, active file,
// cursor line and scroll position when the user returns to the same language.
// Keys are scoped by the logged-in user id so projects are never shared between users.

const uid = () => localStorage.getItem("kiq_uid") || "anon";
const KEY = (lang) => `kiq_ws_${uid()}_${lang}`;

// One-time cleanup of legacy unscoped keys (kiq_ws_<lang>) that could leak across users.
const LEGACY = ["html", "python", "ml", "java", "javascript", "cpp", "sql", "backend"];
try { LEGACY.forEach((l) => localStorage.removeItem(`kiq_ws_${l}`)); } catch {}

export const STARTER_FILE = {
  html: "index.html", python: "main.py", ml: "main.py", java: "Main.java",
  javascript: "index.js", cpp: "main.cpp", sql: "query.sql",
};
export const categoryOf = (lang) => (lang === "sql" || lang === "backend" ? "backend" : "frontend");
export const starterFiles = (lang) => [{ name: STARTER_FILE[lang] || "index.txt", content: "" }];

export function getWs(lang) {
  try { const raw = localStorage.getItem(KEY(lang)); return raw ? JSON.parse(raw) : null; } catch { return null; }
}
export function setWs(lang, ws) {
  try { localStorage.setItem(KEY(lang), JSON.stringify({ ...ws, owner: uid() })); } catch {}
}
export function clearWs(lang) {
  try { localStorage.removeItem(KEY(lang)); } catch {}
}

// Remove any stored workspace that references the given project id (stale/deleted project).
export function clearWsByProjectId(projectId) {
  try {
    Object.keys(localStorage)
      .filter((k) => k.startsWith("kiq_ws_"))
      .forEach((k) => {
        try {
          const ws = JSON.parse(localStorage.getItem(k));
          if (ws && ws.projectId === projectId) localStorage.removeItem(k);
        } catch {}
      });
  } catch {}
}

// Persist a workspace draft to the database (create if new, update if existing).
export async function saveWsToDb(ws) {
  if (!ws) return null;
  if (ws.projectId) {
    await api.put(`/projects/${ws.projectId}`, { name: ws.name, files: ws.files });
    return ws.projectId;
  }
  const { data } = await api.post("/projects", {
    name: ws.name, category: ws.category || categoryOf(ws.language), language: ws.language, files: ws.files,
  });
  return data.id;
}
